export const BackDocumentScanImage: any = {
  v: '5.5.2',
  fr: 25,
  ip: 0,
  op: 126,
  w: 160,
  h: 165,
  nm: 'Validación Cédula_03',
  ddd: 1,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Capa 3 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            r: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                    ],
                    y: [
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                    ],
                    y: [
                      0,
                    ],
                  },
                  t: 8,
                  s: [
                    42,
                  ],
                },
                {
                  t: 17,
                  s: [
                    0,
                  ],
                },
              ],
              ix: 10,
            },
            p: {
              a: 0,
              k: [
                78.753,
                81.23,
                0,
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                65.568,
                63.76,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 8,
                  s: [
                    5,
                    5,
                    100,
                  ],
                },
                {
                  t: 22,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -1.501,
                        ],
                        [
                          1.5,
                          0,
                        ],
                        [
                          0,
                          1.501,
                        ],
                        [
                          -1.501,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          1.501,
                        ],
                        [
                          -1.501,
                          0,
                        ],
                        [
                          0,
                          -1.501,
                        ],
                        [
                          1.5,
                          0,
                        ],
                      ],
                      v: [
                        [
                          2.717,
                          0,
                        ],
                        [
                          0,
                          2.717,
                        ],
                        [
                          -2.717,
                          0,
                        ],
                        [
                          0,
                          -2.717,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      128.168,
                      124.554,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.003,
                          -0.553,
                        ],
                        [
                          0.434,
                          -0.168,
                        ],
                        [
                          0.769,
                          -2.139,
                        ],
                        [
                          0.46,
                          0.008,
                        ],
                        [
                          0.184,
                          0.525,
                        ],
                        [
                          1.227,
                          0.861,
                        ],
                        [
                          0.588,
                          0.27,
                        ],
                        [
                          0.025,
                          0.489,
                        ],
                        [
                          -0.512,
                          0.201,
                        ],
                        [
                          -0.756,
                          2.107,
                        ],
                        [
                          -0.468,
                          0.003,
                        ],
                        [
                          -0.203,
                          -0.564,
                        ],
                        [
                          -2.063,
                          -0.815,
                        ],
                      ],
                      o: [
                        [
                          -0.009,
                          0.445,
                        ],
                        [
                          -2.119,
                          0.819,
                        ],
                        [
                          -0.188,
                          0.522,
                        ],
                        [
                          -0.454,
                          -0.007,
                        ],
                        [
                          -0.494,
                          -1.417,
                        ],
                        [
                          -0.527,
                          -0.37,
                        ],
                        [
                          -0.438,
                          -0.201,
                        ],
                        [
                          -0.023,
                          -0.45,
                        ],
                        [
                          2.085,
                          -0.817,
                        ],
                        [
                          0.19,
                          -0.53,
                        ],
                        [
                          0.488,
                          -0.004,
                        ],
                        [
                          0.754,
                          2.089,
                        ],
                        [
                          0.458,
                          0.181,
                        ],
                      ],
                      v: [
                        [
                          6.003,
                          0.027,
                        ],
                        [
                          5.32,
                          0.948,
                        ],
                        [
                          0.99,
                          5.384,
                        ],
                        [
                          0.001,
                          6.148,
                        ],
                        [
                          -0.973,
                          5.356,
                        ],
                        [
                          -3.527,
                          1.902,
                        ],
                        [
                          -5.234,
                          0.979,
                        ],
                        [
                          -5.98,
                          0.014,
                        ],
                        [
                          -5.23,
                          -0.989,
                        ],
                        [
                          -0.975,
                          -5.375,
                        ],
                        [
                          0.008,
                          -6.152,
                        ],
                        [
                          1.012,
                          -5.349,
                        ],
                        [
                          5.242,
                          -0.997,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      6.253,
                      6.406,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 8,
          op: 758,
          st: 8,
          bm: 0,
        },
        {
          ddd: 1,
          ind: 3,
          ty: 4,
          nm: 'Capa 4 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8,
            },
            ry: {
              a: 0,
              k: 0,
              ix: 9,
            },
            rz: {
              a: 0,
              k: 0,
              ix: 10,
            },
            or: {
              a: 0,
              k: [
                0,
                0,
                0,
              ],
              ix: 7,
            },
            p: {
              a: 0,
              k: [
                78.753,
                81.23,
                0,
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                36.864,
                77.068,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 9,
                  s: [
                    19,
                    19,
                    19,
                  ],
                },
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 17,
                  s: [
                    113,
                    113,
                    113,
                  ],
                },
                {
                  t: 26,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.536,
                          -0.807,
                        ],
                        [
                          -0.464,
                          -0.7,
                        ],
                        [
                          0.537,
                          0.807,
                        ],
                        [
                          0.465,
                          0.7,
                        ],
                      ],
                      o: [
                        [
                          0.465,
                          0.7,
                        ],
                        [
                          0.532,
                          0.8,
                        ],
                        [
                          -0.464,
                          -0.7,
                        ],
                        [
                          -0.531,
                          -0.801,
                        ],
                      ],
                      v: [
                        [
                          -1.345,
                          -0.671,
                        ],
                        [
                          0.049,
                          1.429,
                        ],
                        [
                          1.344,
                          0.672,
                        ],
                        [
                          -0.05,
                          -1.428,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.131,
                      151.657,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0.873,
                          0.414,
                        ],
                        [
                          1.753,
                          1.8,
                        ],
                        [
                          -0.673,
                          -0.692,
                        ],
                        [
                          -2.38,
                          -1.128,
                        ],
                      ],
                      o: [
                        [
                          -2.271,
                          -1.076,
                        ],
                        [
                          -0.675,
                          -0.693,
                        ],
                        [
                          1.838,
                          1.887,
                        ],
                        [
                          0.868,
                          0.412,
                        ],
                      ],
                      v: [
                        [
                          3.45,
                          1.646,
                        ],
                        [
                          -2.588,
                          -2.66,
                        ],
                        [
                          -3.65,
                          -1.6,
                        ],
                        [
                          2.693,
                          2.942,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      69.155,
                      3.604,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 9,
          op: 759,
          st: 9,
          bm: 0,
        },
        {
          ddd: 1,
          ind: 5,
          ty: 4,
          nm: 'Capa 1 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8,
            },
            ry: {
              a: 0,
              k: 0,
              ix: 9,
            },
            rz: {
              a: 0,
              k: 0,
              ix: 10,
            },
            or: {
              a: 0,
              k: [
                0,
                0,
                0,
              ],
              ix: 7,
            },
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 0.768,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  t: 0,
                  s: [
                    78.571,
                    80.759,
                    42,
                  ],
                  to: [
                    0,
                    0,
                    -5.569,
                  ],
                  ti: [
                    0,
                    0,
                    11.003,
                  ],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0.396,
                  },
                  t: 15,
                  s: [
                    78.571,
                    80.759,
                    -8.936,
                  ],
                  to: [
                    0,
                    0,
                    -2.826,
                  ],
                  ti: [
                    0,
                    0,
                    1.431,
                  ],
                },
                {
                  t: 20,
                  s: [
                    78.571,
                    80.759,
                    0,
                  ],
                },
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                72.688,
                71.924,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 0,
                  s: [
                    11,
                    11,
                    11,
                  ],
                },
                {
                  t: 5,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.501,
                          -0.829,
                        ],
                        [
                          -1.184,
                          -0.353,
                        ],
                        [
                          0.925,
                          0.276,
                        ],
                        [
                          0.436,
                          0.723,
                        ],
                      ],
                      o: [
                        [
                          0.64,
                          1.057,
                        ],
                        [
                          0.926,
                          0.276,
                        ],
                        [
                          -0.809,
                          -0.241,
                        ],
                        [
                          -0.499,
                          -0.825,
                        ],
                      ],
                      v: [
                        [
                          -1.813,
                          -0.431,
                        ],
                        [
                          0.991,
                          1.737,
                        ],
                        [
                          1.389,
                          0.29,
                        ],
                        [
                          -0.517,
                          -1.188,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      142.813,
                      54.545,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -1.5,
                        ],
                        [
                          1.501,
                          0,
                        ],
                        [
                          0,
                          1.5,
                        ],
                        [
                          -1.5,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          1.5,
                        ],
                        [
                          -1.5,
                          0,
                        ],
                        [
                          0,
                          -1.5,
                        ],
                        [
                          1.501,
                          0,
                        ],
                      ],
                      v: [
                        [
                          2.717,
                          0,
                        ],
                        [
                          0,
                          2.717,
                        ],
                        [
                          -2.717,
                          0,
                        ],
                        [
                          0,
                          -2.717,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      133.255,
                      44.064,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0.483,
                          0.839,
                        ],
                        [
                          0.048,
                          0.698,
                        ],
                        [
                          -0.067,
                          -0.965,
                        ],
                        [
                          -0.484,
                          -0.84,
                        ],
                      ],
                      o: [
                        [
                          -0.348,
                          -0.604,
                        ],
                        [
                          -0.066,
                          -0.957,
                        ],
                        [
                          0.067,
                          0.966,
                        ],
                        [
                          0.482,
                          0.836,
                        ],
                      ],
                      v: [
                        [
                          0.846,
                          0.66,
                        ],
                        [
                          0.238,
                          -1.288,
                        ],
                        [
                          -1.262,
                          -1.288,
                        ],
                        [
                          -0.449,
                          1.417,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      27.398,
                      9.5,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 3',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.965,
                          -0.027,
                        ],
                        [
                          -1.761,
                          0.755,
                        ],
                        [
                          0.878,
                          -0.377,
                        ],
                        [
                          1.639,
                          0.047,
                        ],
                      ],
                      o: [
                        [
                          1.919,
                          0.056,
                        ],
                        [
                          0.885,
                          -0.379,
                        ],
                        [
                          -1.51,
                          0.647,
                        ],
                        [
                          -0.965,
                          -0.027,
                        ],
                      ],
                      v: [
                        [
                          -2.707,
                          1.346,
                        ],
                        [
                          2.787,
                          0.27,
                        ],
                        [
                          2.03,
                          -1.025,
                        ],
                        [
                          -2.707,
                          -0.154,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      129.262,
                      142.197,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 4',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.965,
                          -0.026,
                        ],
                        [
                          -1.642,
                          1.077,
                        ],
                        [
                          0.811,
                          -0.532,
                        ],
                        [
                          1.723,
                          0.046,
                        ],
                      ],
                      o: [
                        [
                          1.963,
                          0.052,
                        ],
                        [
                          0.804,
                          -0.528,
                        ],
                        [
                          -1.439,
                          0.944,
                        ],
                        [
                          -0.965,
                          -0.026,
                        ],
                      ],
                      v: [
                        [
                          -2.663,
                          1.665,
                        ],
                        [
                          2.824,
                          0.111,
                        ],
                        [
                          2.066,
                          -1.185,
                        ],
                        [
                          -2.663,
                          0.165,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      3.877,
                      49.923,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 5',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.554,
                          0,
                        ],
                        [
                          0,
                          0.554,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.554,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.554,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.003,
                          0.001,
                        ],
                        [
                          0.001,
                          1.004,
                        ],
                        [
                          -1.003,
                          0.001,
                        ],
                        [
                          0.001,
                          -1.004,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.11,
                      13.916,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 6',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.555,
                          0,
                        ],
                        [
                          0,
                          0.555,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.555,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.555,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.004,
                          0,
                        ],
                        [
                          0,
                          1.004,
                        ],
                        [
                          -1.004,
                          0,
                        ],
                        [
                          0,
                          -1.004,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      100.693,
                      128.689,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 7',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 7,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.916,
                        ],
                        [
                          0.916,
                          0,
                        ],
                        [
                          0,
                          0.915,
                        ],
                        [
                          -0.916,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.915,
                        ],
                        [
                          -0.916,
                          0,
                        ],
                        [
                          0,
                          -0.916,
                        ],
                        [
                          0.916,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.658,
                          0,
                        ],
                        [
                          0,
                          1.658,
                        ],
                        [
                          -1.658,
                          0,
                        ],
                        [
                          0,
                          -1.658,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.11,
                      135.126,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 8',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 8,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -1.243,
                          0.643,
                        ],
                        [
                          0.612,
                          1.25,
                        ],
                        [
                          1.208,
                          -0.633,
                        ],
                        [
                          -0.202,
                          -0.134,
                        ],
                        [
                          0.142,
                          -0.23,
                        ],
                        [
                          0.283,
                          0.149,
                        ],
                        [
                          0.374,
                          0.176,
                        ],
                        [
                          -0.005,
                          0.325,
                        ],
                        [
                          -0.299,
                          0.114,
                        ],
                        [
                          -0.59,
                          1.081,
                        ],
                        [
                          -0.103,
                          0.267,
                        ],
                        [
                          -0.339,
                          0.013,
                        ],
                        [
                          -0.126,
                          -0.355,
                        ],
                        [
                          -1.441,
                          -0.565,
                        ],
                        [
                          -0.002,
                          -0.334,
                        ],
                        [
                          0.308,
                          -0.12,
                        ],
                        [
                          0.521,
                          -1.462,
                        ],
                        [
                          0.326,
                          0.005,
                        ],
                        [
                          0.124,
                          0.307,
                        ],
                        [
                          0.148,
                          0.305,
                        ],
                        [
                          -0.254,
                          0.136,
                        ],
                        [
                          -0.175,
                          -0.296,
                        ],
                        [
                          -0.096,
                          -0.173,
                        ],
                      ],
                      o: [
                        [
                          -1.226,
                          -0.643,
                        ],
                        [
                          -0.61,
                          1.238,
                        ],
                        [
                          0.247,
                          0.151,
                        ],
                        [
                          0.264,
                          0.176,
                        ],
                        [
                          -0.144,
                          0.235,
                        ],
                        [
                          -0.365,
                          -0.194,
                        ],
                        [
                          -0.289,
                          -0.136,
                        ],
                        [
                          0.005,
                          -0.326,
                        ],
                        [
                          1.15,
                          -0.437,
                        ],
                        [
                          0.137,
                          -0.251,
                        ],
                        [
                          0.118,
                          -0.309,
                        ],
                        [
                          0.319,
                          -0.011,
                        ],
                        [
                          0.52,
                          1.462,
                        ],
                        [
                          0.311,
                          0.122,
                        ],
                        [
                          0.002,
                          0.335,
                        ],
                        [
                          -1.448,
                          0.558,
                        ],
                        [
                          -0.128,
                          0.359,
                        ],
                        [
                          -0.343,
                          -0.006,
                        ],
                        [
                          -0.126,
                          -0.315,
                        ],
                        [
                          -0.154,
                          -0.314,
                        ],
                        [
                          0.25,
                          -0.133,
                        ],
                        [
                          0.081,
                          0.136,
                        ],
                        [
                          0.606,
                          -1.222,
                        ],
                      ],
                      v: [
                        [
                          2.73,
                          0.007,
                        ],
                        [
                          0.001,
                          -2.784,
                        ],
                        [
                          -2.713,
                          0.001,
                        ],
                        [
                          -2.053,
                          0.406,
                        ],
                        [
                          -1.855,
                          1.09,
                        ],
                        [
                          -2.553,
                          1.221,
                        ],
                        [
                          -3.66,
                          0.658,
                        ],
                        [
                          -4.116,
                          -0.006,
                        ],
                        [
                          -3.638,
                          -0.653,
                        ],
                        [
                          -1.016,
                          -2.921,
                        ],
                        [
                          -0.671,
                          -3.709,
                        ],
                        [
                          -0.012,
                          -4.221,
                        ],
                        [
                          0.671,
                          -3.701,
                        ],
                        [
                          3.616,
                          -0.663,
                        ],
                        [
                          4.119,
                          0.003,
                        ],
                        [
                          3.622,
                          0.674,
                        ],
                        [
                          0.673,
                          3.706,
                        ],
                        [
                          -0.008,
                          4.227,
                        ],
                        [
                          -0.671,
                          3.723,
                        ],
                        [
                          -1.09,
                          2.795,
                        ],
                        [
                          -0.938,
                          2.073,
                        ],
                        [
                          -0.248,
                          2.334,
                        ],
                        [
                          0.003,
                          2.783,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      136.334,
                      4.482,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 9',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 9,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 750,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Capa 3 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 23,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 32,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 100,
              s: [
                100,
              ],
            },
            {
              t: 115,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.27,
                      0.542,
                    ],
                    [
                      0.151,
                      0.131,
                    ],
                    [
                      0.59,
                      -0.585,
                    ],
                    [
                      1.999,
                      -0.998,
                    ],
                    [
                      -0.046,
                      -0.093,
                    ],
                    [
                      -0.093,
                      0.046,
                    ],
                    [
                      -0.393,
                      0.389,
                    ],
                    [
                      -0.45,
                      -0.388,
                    ],
                    [
                      -0.066,
                      -0.134,
                    ],
                    [
                      0.296,
                      -0.346,
                    ],
                    [
                      0.986,
                      -0.521,
                    ],
                    [
                      -0.046,
                      -0.092,
                    ],
                    [
                      -0.001,
                      -0.001,
                    ],
                    [
                      -0.091,
                      0.048,
                    ],
                    [
                      -0.625,
                      0.73,
                    ],
                  ],
                  o: [
                    [
                      -0.09,
                      -0.178,
                    ],
                    [
                      -0.6,
                      -0.518,
                    ],
                    [
                      -0.322,
                      0.318,
                    ],
                    [
                      -0.094,
                      0.046,
                    ],
                    [
                      0.046,
                      0.093,
                    ],
                    [
                      1.799,
                      -0.898,
                    ],
                    [
                      0.45,
                      -0.445,
                    ],
                    [
                      0.113,
                      0.099,
                    ],
                    [
                      0.203,
                      0.406,
                    ],
                    [
                      -0.586,
                      0.684,
                    ],
                    [
                      -0.09,
                      0.047,
                    ],
                    [
                      0,
                      0.001,
                    ],
                    [
                      0.047,
                      0.092,
                    ],
                    [
                      1.015,
                      -0.536,
                    ],
                    [
                      0.393,
                      -0.46,
                    ],
                  ],
                  v: [
                    [
                      3.295,
                      -1.385,
                    ],
                    [
                      2.933,
                      -1.851,
                    ],
                    [
                      0.847,
                      -1.734,
                    ],
                    [
                      -3.434,
                      0.694,
                    ],
                    [
                      -3.519,
                      0.945,
                    ],
                    [
                      -3.267,
                      1.03,
                    ],
                    [
                      1.111,
                      -1.467,
                    ],
                    [
                      2.687,
                      -1.567,
                    ],
                    [
                      2.958,
                      -1.217,
                    ],
                    [
                      2.805,
                      0.02,
                    ],
                    [
                      -0.065,
                      1.989,
                    ],
                    [
                      -0.145,
                      2.239,
                    ],
                    [
                      -0.143,
                      2.242,
                    ],
                    [
                      0.11,
                      2.321,
                    ],
                    [
                      3.091,
                      0.263,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  85.852,
                  46.375,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.124,
                      0.061,
                    ],
                    [
                      0.046,
                      0.093,
                    ],
                    [
                      0.001,
                      0,
                    ],
                    [
                      0.093,
                      -0.046,
                    ],
                    [
                      0.197,
                      -0.104,
                    ],
                    [
                      0.215,
                      -0.098,
                    ],
                    [
                      -0.043,
                      -0.094,
                    ],
                    [
                      -0.001,
                      -0.002,
                    ],
                    [
                      -0.093,
                      0.042,
                    ],
                    [
                      -0.291,
                      0.154,
                    ],
                  ],
                  o: [
                    [
                      0.093,
                      -0.046,
                    ],
                    [
                      0,
                      -0.001,
                    ],
                    [
                      -0.046,
                      -0.093,
                    ],
                    [
                      -0.127,
                      0.062,
                    ],
                    [
                      -0.286,
                      0.151,
                    ],
                    [
                      -0.095,
                      0.043,
                    ],
                    [
                      0.001,
                      0.003,
                    ],
                    [
                      0.045,
                      0.089,
                    ],
                    [
                      0.225,
                      -0.102,
                    ],
                    [
                      0.192,
                      -0.102,
                    ],
                  ],
                  v: [
                    [
                      0.751,
                      -0.173,
                    ],
                    [
                      0.837,
                      -0.424,
                    ],
                    [
                      0.836,
                      -0.425,
                    ],
                    [
                      0.586,
                      -0.51,
                    ],
                    [
                      0.079,
                      -0.248,
                    ],
                    [
                      -0.747,
                      0.173,
                    ],
                    [
                      -0.84,
                      0.421,
                    ],
                    [
                      -0.837,
                      0.428,
                    ],
                    [
                      -0.591,
                      0.514,
                    ],
                    [
                      0.255,
                      0.084,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  84.351,
                  49.26,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.9,
                      -0.487,
                    ],
                    [
                      -0.049,
                      0.092,
                    ],
                    [
                      0.092,
                      0.049,
                    ],
                    [
                      0.978,
                      -0.872,
                    ],
                    [
                      1.941,
                      -0.968,
                    ],
                    [
                      -0.047,
                      -0.094,
                    ],
                    [
                      -0.093,
                      0.047,
                    ],
                    [
                      -0.044,
                      0.039,
                    ],
                  ],
                  o: [
                    [
                      0.092,
                      0.05,
                    ],
                    [
                      0.05,
                      -0.091,
                    ],
                    [
                      -1.039,
                      -0.563,
                    ],
                    [
                      -0.011,
                      0.009,
                    ],
                    [
                      -0.093,
                      0.046,
                    ],
                    [
                      0.046,
                      0.092,
                    ],
                    [
                      1.986,
                      -0.99,
                    ],
                    [
                      0.859,
                      -0.765,
                    ],
                  ],
                  v: [
                    [
                      3.022,
                      -0.806,
                    ],
                    [
                      3.277,
                      -0.882,
                    ],
                    [
                      3.201,
                      -1.136,
                    ],
                    [
                      -0.173,
                      -0.621,
                    ],
                    [
                      -3.195,
                      1.317,
                    ],
                    [
                      -3.279,
                      1.569,
                    ],
                    [
                      -3.027,
                      1.652,
                    ],
                    [
                      0.079,
                      -0.342,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  85.949,
                  44.324,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.507,
                      1.015,
                    ],
                    [
                      0.127,
                      0.157,
                    ],
                    [
                      0.08,
                      -0.064,
                    ],
                    [
                      -0.065,
                      -0.082,
                    ],
                    [
                      -0.079,
                      -0.157,
                    ],
                    [
                      0.64,
                      -0.747,
                    ],
                    [
                      2.749,
                      -1.254,
                    ],
                    [
                      -0.043,
                      -0.094,
                    ],
                    [
                      -0.001,
                      -0.001,
                    ],
                    [
                      -0.091,
                      0.042,
                    ],
                    [
                      -0.811,
                      0.949,
                    ],
                  ],
                  o: [
                    [
                      -0.091,
                      -0.183,
                    ],
                    [
                      -0.066,
                      -0.081,
                    ],
                    [
                      -0.081,
                      0.066,
                    ],
                    [
                      0.109,
                      0.135,
                    ],
                    [
                      0.439,
                      0.88,
                    ],
                    [
                      -0.761,
                      0.89,
                    ],
                    [
                      -0.095,
                      0.043,
                    ],
                    [
                      0.001,
                      0.002,
                    ],
                    [
                      0.045,
                      0.09,
                    ],
                    [
                      2.861,
                      -1.304,
                    ],
                    [
                      0.738,
                      -0.861,
                    ],
                  ],
                  v: [
                    [
                      2.671,
                      -2.784,
                    ],
                    [
                      2.343,
                      -3.294,
                    ],
                    [
                      2.079,
                      -3.324,
                    ],
                    [
                      2.051,
                      -3.059,
                    ],
                    [
                      2.335,
                      -2.617,
                    ],
                    [
                      2.005,
                      0.061,
                    ],
                    [
                      -3.04,
                      3.005,
                    ],
                    [
                      -3.134,
                      3.253,
                    ],
                    [
                      -3.132,
                      3.258,
                    ],
                    [
                      -2.885,
                      3.346,
                    ],
                    [
                      2.29,
                      0.305,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.652,
                  47.186,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.622,
                      1.368,
                    ],
                    [
                      0.434,
                      0.375,
                    ],
                    [
                      1.474,
                      -1.342,
                    ],
                    [
                      0.168,
                      -0.118,
                    ],
                    [
                      1.203,
                      -0.6,
                    ],
                    [
                      -0.045,
                      -0.094,
                    ],
                    [
                      -0.092,
                      0.046,
                    ],
                    [
                      -0.404,
                      0.281,
                    ],
                    [
                      -0.156,
                      0.142,
                    ],
                    [
                      -1.366,
                      -1.181,
                    ],
                    [
                      -0.216,
                      -0.47,
                    ],
                    [
                      1,
                      -1.01,
                    ],
                    [
                      1.62,
                      -0.754,
                    ],
                    [
                      -0.044,
                      -0.094,
                    ],
                    [
                      -0.093,
                      0.044,
                    ],
                    [
                      -0.908,
                      0.915,
                    ],
                  ],
                  o: [
                    [
                      -0.237,
                      -0.524,
                    ],
                    [
                      -1.509,
                      -1.305,
                    ],
                    [
                      -0.148,
                      0.134,
                    ],
                    [
                      -0.382,
                      0.265,
                    ],
                    [
                      -0.092,
                      0.046,
                    ],
                    [
                      0.047,
                      0.092,
                    ],
                    [
                      1.254,
                      -0.625,
                    ],
                    [
                      0.187,
                      -0.13,
                    ],
                    [
                      1.333,
                      -1.215,
                    ],
                    [
                      0.392,
                      0.339,
                    ],
                    [
                      0.553,
                      1.217,
                    ],
                    [
                      -0.865,
                      0.873,
                    ],
                    [
                      -0.094,
                      0.044,
                    ],
                    [
                      0.047,
                      0.09,
                    ],
                    [
                      1.652,
                      -0.768,
                    ],
                    [
                      1.118,
                      -1.128,
                    ],
                  ],
                  v: [
                    [
                      4.283,
                      -2.252,
                    ],
                    [
                      3.27,
                      -3.605,
                    ],
                    [
                      -1.962,
                      -3.54,
                    ],
                    [
                      -2.436,
                      -3.148,
                    ],
                    [
                      -4.776,
                      -1.901,
                    ],
                    [
                      -4.86,
                      -1.65,
                    ],
                    [
                      -4.608,
                      -1.566,
                    ],
                    [
                      -2.221,
                      -2.84,
                    ],
                    [
                      -1.709,
                      -3.262,
                    ],
                    [
                      3.025,
                      -3.32,
                    ],
                    [
                      3.941,
                      -2.096,
                    ],
                    [
                      3.116,
                      2.01,
                    ],
                    [
                      -1.144,
                      4.525,
                    ],
                    [
                      -1.235,
                      4.775,
                    ],
                    [
                      -0.986,
                      4.867,
                    ],
                    [
                      3.383,
                      2.275,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.111,
                  46.282,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -1.784,
                      -0.611,
                    ],
                    [
                      -0.033,
                      0.098,
                    ],
                    [
                      0.098,
                      0.034,
                    ],
                    [
                      2.411,
                      -2.255,
                    ],
                    [
                      -0.037,
                      -0.072,
                    ],
                    [
                      -0.013,
                      -0.014,
                    ],
                    [
                      -0.076,
                      0.07,
                    ],
                  ],
                  o: [
                    [
                      0.099,
                      0.034,
                    ],
                    [
                      0.034,
                      -0.098,
                    ],
                    [
                      -1.342,
                      -0.46,
                    ],
                    [
                      -0.063,
                      0.058,
                    ],
                    [
                      0.007,
                      0.016,
                    ],
                    [
                      0.07,
                      0.076,
                    ],
                    [
                      1.8,
                      -1.685,
                    ],
                  ],
                  v: [
                    [
                      2.77,
                      -0.411,
                    ],
                    [
                      3.008,
                      -0.528,
                    ],
                    [
                      2.892,
                      -0.766,
                    ],
                    [
                      -2.965,
                      0.955,
                    ],
                    [
                      -3.005,
                      1.176,
                    ],
                    [
                      -2.974,
                      1.221,
                    ],
                    [
                      -2.709,
                      1.23,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  86.385,
                  41.511,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.516,
                      0.604,
                    ],
                    [
                      0.911,
                      1.827,
                    ],
                    [
                      0.51,
                      0.441,
                    ],
                    [
                      0.306,
                      0.18,
                    ],
                    [
                      0.053,
                      -0.09,
                    ],
                    [
                      -0.089,
                      -0.052,
                    ],
                    [
                      -0.265,
                      -0.229,
                    ],
                    [
                      -0.28,
                      -0.558,
                    ],
                    [
                      1.229,
                      -1.437,
                    ],
                    [
                      0.622,
                      -0.389,
                    ],
                    [
                      -0.043,
                      -0.086,
                    ],
                    [
                      -0.004,
                      -0.006,
                    ],
                    [
                      -0.088,
                      0.055,
                    ],
                  ],
                  o: [
                    [
                      1.327,
                      -1.551,
                    ],
                    [
                      -0.301,
                      -0.603,
                    ],
                    [
                      -0.282,
                      -0.244,
                    ],
                    [
                      -0.09,
                      -0.052,
                    ],
                    [
                      -0.052,
                      0.089,
                    ],
                    [
                      0.286,
                      0.168,
                    ],
                    [
                      0.472,
                      0.409,
                    ],
                    [
                      0.843,
                      1.692,
                    ],
                    [
                      -0.512,
                      0.597,
                    ],
                    [
                      -0.083,
                      0.053,
                    ],
                    [
                      0.002,
                      0.005,
                    ],
                    [
                      0.055,
                      0.087,
                    ],
                    [
                      0.781,
                      -0.49,
                    ],
                  ],
                  v: [
                    [
                      0.526,
                      2.983,
                    ],
                    [
                      1.212,
                      -2.578,
                    ],
                    [
                      -0.01,
                      -4.151,
                    ],
                    [
                      -0.898,
                      -4.79,
                    ],
                    [
                      -1.154,
                      -4.723,
                    ],
                    [
                      -1.088,
                      -4.466,
                    ],
                    [
                      -0.257,
                      -3.867,
                    ],
                    [
                      0.876,
                      -2.411,
                    ],
                    [
                      0.241,
                      2.739,
                    ],
                    [
                      -2.012,
                      4.468,
                    ],
                    [
                      -2.079,
                      4.712,
                    ],
                    [
                      -2.07,
                      4.728,
                    ],
                    [
                      -1.812,
                      4.787,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  91.129,
                  45.975,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.07,
                      0.077,
                    ],
                    [
                      0.078,
                      -0.071,
                    ],
                    [
                      3.608,
                      -1.646,
                    ],
                    [
                      -0.043,
                      -0.094,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.092,
                      0.042,
                    ],
                    [
                      -0.056,
                      0.052,
                    ],
                  ],
                  o: [
                    [
                      -0.07,
                      -0.076,
                    ],
                    [
                      -0.012,
                      0.012,
                    ],
                    [
                      -0.095,
                      0.043,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.045,
                      0.09,
                    ],
                    [
                      3.662,
                      -1.67,
                    ],
                    [
                      0.076,
                      -0.07,
                    ],
                  ],
                  v: [
                    [
                      2.663,
                      -1.597,
                    ],
                    [
                      2.396,
                      -1.607,
                    ],
                    [
                      -2.596,
                      1.296,
                    ],
                    [
                      -2.689,
                      1.544,
                    ],
                    [
                      -2.687,
                      1.549,
                    ],
                    [
                      -2.441,
                      1.637,
                    ],
                    [
                      2.652,
                      -1.331,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  85.277,
                  47.13,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.815,
                      6.983,
                    ],
                    [
                      -3.001,
                      -6.919,
                    ],
                    [
                      -2.815,
                      -6.984,
                    ],
                    [
                      3.001,
                      6.919,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  92.053,
                  67.873,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.654,
                      6.599,
                    ],
                    [
                      -2.841,
                      -6.536,
                    ],
                    [
                      -2.655,
                      -6.6,
                    ],
                    [
                      2.841,
                      6.535,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  95.887,
                  64.924,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.965,
                      7.342,
                    ],
                    [
                      -3.151,
                      -7.277,
                    ],
                    [
                      -2.965,
                      -7.342,
                    ],
                    [
                      3.152,
                      7.278,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  94.358,
                  66.877,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.474,
                      6.675,
                    ],
                    [
                      -3.032,
                      -6.484,
                    ],
                    [
                      -2.473,
                      -6.676,
                    ],
                    [
                      3.033,
                      6.483,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  98.441,
                  62.847,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.008,
                      0.019,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.019,
                      0.007,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.008,
                      -0.019,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.019,
                      -0.007,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.008,
                      -0.019,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.018,
                      -0.007,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.008,
                      0.019,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.019,
                      0.007,
                    ],
                  ],
                  v: [
                    [
                      5.19,
                      21.999,
                    ],
                    [
                      -10.234,
                      -18.755,
                    ],
                    [
                      -10.213,
                      -18.801,
                    ],
                    [
                      -5.237,
                      -22.021,
                    ],
                    [
                      -5.19,
                      -22,
                    ],
                    [
                      10.234,
                      18.755,
                    ],
                    [
                      10.213,
                      18.801,
                    ],
                    [
                      5.237,
                      22.021,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  81.879,
                  64.395,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -2.209,
                      -1.3,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.421,
                      1.111,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.742,
                      0.477,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.421,
                      -1.112,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.708,
                      -1.304,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1,
                      0.642,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.312,
                      -0.825,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1,
                      -0.642,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.708,
                      1.303,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      17.462,
                      18.695,
                    ],
                    [
                      -0.459,
                      30.201,
                    ],
                    [
                      -3.218,
                      29.29,
                    ],
                    [
                      -4.79,
                      25.129,
                    ],
                    [
                      -19.719,
                      -14.192,
                    ],
                    [
                      -18.982,
                      -16.424,
                    ],
                    [
                      2.454,
                      -30.201,
                    ],
                    [
                      5.213,
                      -29.288,
                    ],
                    [
                      6.788,
                      -25.122,
                    ],
                    [
                      20.031,
                      9.758,
                    ],
                    [
                      18.278,
                      12.79,
                    ],
                    [
                      16.604,
                      15.928,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.987999949736,
                  0.905999995213,
                  0.905999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  86.545,
                  59.861,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: -6,
      op: 744,
      st: -6,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Capa 2 contornos',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.634,
                      -0.542,
                    ],
                    [
                      -9.608,
                      -0.189,
                    ],
                    [
                      -1.091,
                      -0.398,
                    ],
                    [
                      -1.511,
                      -1.296,
                    ],
                    [
                      1.862,
                      0.646,
                    ],
                    [
                      2.453,
                      -0.137,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.758,
                      0.035,
                    ],
                    [
                      1.714,
                      0.626,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.678,
                      -0.582,
                    ],
                    [
                      -4.412,
                      0.246,
                    ],
                  ],
                  v: [
                    [
                      -9.961,
                      -0.777,
                    ],
                    [
                      0.852,
                      -1.986,
                    ],
                    [
                      5.04,
                      -1.433,
                    ],
                    [
                      9.961,
                      2.175,
                    ],
                    [
                      4.807,
                      -1.203,
                    ],
                    [
                      -2.879,
                      -1.672,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  121.205,
                  65.081,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.764,
                      -0.66,
                    ],
                    [
                      -0.323,
                      1.563,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.691,
                      -1.725,
                    ],
                    [
                      -0.692,
                      1.725,
                    ],
                    [
                      0.649,
                      -0.686,
                    ],
                    [
                      0.512,
                      -0.894,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  139.903,
                  91.915,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.189,
                      -0.054,
                    ],
                    [
                      -0.552,
                      1.074,
                    ],
                    [
                      1.609,
                      -0.847,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.727,
                      1.366,
                    ],
                    [
                      1.728,
                      -1.369,
                    ],
                    [
                      -1.062,
                      1.369,
                    ],
                    [
                      -1.253,
                      1.198,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  125.854,
                  112.226,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      5.1,
                      -1.513,
                    ],
                    [
                      -3.555,
                      8.655,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -3.181,
                      4.45,
                    ],
                    [
                      3.182,
                      -4.45,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  136.34,
                  103.119,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -1.344,
                      4.502,
                    ],
                    [
                      -3.493,
                      -1.754,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.612,
                      -2.973,
                    ],
                    [
                      1.747,
                      2.974,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  113.365,
                  106.836,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.783,
                      -0.207,
                    ],
                    [
                      -1.092,
                      0.055,
                    ],
                    [
                      2.066,
                      0.838,
                    ],
                    [
                      0.923,
                      0.7,
                    ],
                  ],
                  o: [
                    [
                      0.765,
                      0.545,
                    ],
                    [
                      2.268,
                      0.602,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.913,
                      -0.371,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -3.82,
                      -0.445,
                    ],
                    [
                      -1.432,
                      0.79,
                    ],
                    [
                      4.173,
                      1.173,
                    ],
                    [
                      -1.257,
                      0.409,
                    ],
                    [
                      -4.174,
                      -1.392,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  130.847,
                  91.906,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.717,
                      0.202,
                    ],
                    [
                      1.056,
                      -1.209,
                    ],
                    [
                      1.874,
                      -1.984,
                    ],
                    [
                      2.314,
                      1.002,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.406,
                      1.772,
                    ],
                    [
                      -0.671,
                      0.428,
                    ],
                    [
                      -2.628,
                      -0.123,
                    ],
                  ],
                  o: [
                    [
                      -0.672,
                      -0.672,
                    ],
                    [
                      -0.857,
                      0.367,
                    ],
                    [
                      -0.924,
                      -0.108,
                    ],
                    [
                      -0.921,
                      1.057,
                    ],
                    [
                      -2.67,
                      2.829,
                    ],
                    [
                      -3.153,
                      -1.366,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.405,
                      -1.772,
                    ],
                    [
                      0.673,
                      -0.428,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      10.766,
                      3.513,
                    ],
                    [
                      8.624,
                      2.535,
                    ],
                    [
                      5.704,
                      1.614,
                    ],
                    [
                      2.667,
                      1.451,
                    ],
                    [
                      -0.18,
                      5.162,
                    ],
                    [
                      -7.613,
                      7.34,
                    ],
                    [
                      -9.167,
                      4.223,
                    ],
                    [
                      -4.756,
                      -3.392,
                    ],
                    [
                      -1.213,
                      -7.181,
                    ],
                    [
                      4.656,
                      -8.219,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  112.315,
                  71.565,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.25,
                      -0.16,
                    ],
                    [
                      1.758,
                      -1.118,
                    ],
                    [
                      -0.112,
                      -0.046,
                    ],
                    [
                      0.764,
                      2.02,
                    ],
                    [
                      -0.105,
                      -0.278,
                    ],
                    [
                      -0.765,
                      -2.021,
                    ],
                    [
                      -0.136,
                      0.086,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -1.758,
                      1.118,
                    ],
                    [
                      0.113,
                      0.046,
                    ],
                    [
                      -0.765,
                      -2.021,
                    ],
                    [
                      -0.105,
                      -0.274,
                    ],
                    [
                      0.766,
                      2.02,
                    ],
                    [
                      0.051,
                      0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.249,
                      -0.158,
                    ],
                  ],
                  v: [
                    [
                      3.651,
                      -0.497,
                    ],
                    [
                      -1.624,
                      2.857,
                    ],
                    [
                      -1.286,
                      2.995,
                    ],
                    [
                      -3.581,
                      -3.066,
                    ],
                    [
                      -4.025,
                      -2.944,
                    ],
                    [
                      -1.73,
                      3.117,
                    ],
                    [
                      -1.391,
                      3.254,
                    ],
                    [
                      3.882,
                      -0.101,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  111.27,
                  67.223,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.25,
                      -0.159,
                    ],
                    [
                      1.757,
                      -1.119,
                    ],
                    [
                      -0.112,
                      -0.046,
                    ],
                    [
                      0.765,
                      2.02,
                    ],
                    [
                      -0.105,
                      -0.278,
                    ],
                    [
                      -0.765,
                      -2.02,
                    ],
                    [
                      -0.136,
                      0.086,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -1.759,
                      1.118,
                    ],
                    [
                      0.112,
                      0.045,
                    ],
                    [
                      -0.765,
                      -2.02,
                    ],
                    [
                      -0.104,
                      -0.274,
                    ],
                    [
                      0.765,
                      2.019,
                    ],
                    [
                      0.05,
                      0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.249,
                      -0.159,
                    ],
                  ],
                  v: [
                    [
                      3.651,
                      -0.498,
                    ],
                    [
                      -1.624,
                      2.857,
                    ],
                    [
                      -1.286,
                      2.995,
                    ],
                    [
                      -3.583,
                      -3.066,
                    ],
                    [
                      -4.025,
                      -2.944,
                    ],
                    [
                      -1.73,
                      3.117,
                    ],
                    [
                      -1.391,
                      3.255,
                    ],
                    [
                      3.882,
                      -0.101,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  83.276,
                  94.119,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.25,
                      0.159,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.765,
                      -2.02,
                    ],
                    [
                      0.104,
                      0.277,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.135,
                      -0.086,
                    ],
                    [
                      1.757,
                      -1.119,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.765,
                      2.02,
                    ],
                    [
                      0.104,
                      0.274,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.05,
                      -0.132,
                    ],
                    [
                      -1.758,
                      1.118,
                    ],
                    [
                      -0.249,
                      0.158,
                    ],
                  ],
                  v: [
                    [
                      -3.65,
                      0.497,
                    ],
                    [
                      1.623,
                      -2.857,
                    ],
                    [
                      1.287,
                      -2.995,
                    ],
                    [
                      3.582,
                      3.066,
                    ],
                    [
                      4.026,
                      2.944,
                    ],
                    [
                      1.729,
                      -3.117,
                    ],
                    [
                      1.392,
                      -3.254,
                    ],
                    [
                      -3.881,
                      0.101,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  90.808,
                  25.998,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.106,
                      0.276,
                    ],
                    [
                      0.189,
                      0.489,
                    ],
                    [
                      -0.107,
                      -0.277,
                    ],
                    [
                      -0.189,
                      -0.489,
                    ],
                  ],
                  o: [
                    [
                      -0.188,
                      -0.489,
                    ],
                    [
                      -0.105,
                      -0.273,
                    ],
                    [
                      0.189,
                      0.489,
                    ],
                    [
                      0.105,
                      0.273,
                    ],
                  ],
                  v: [
                    [
                      0.505,
                      0.673,
                    ],
                    [
                      -0.061,
                      -0.795,
                    ],
                    [
                      -0.504,
                      -0.673,
                    ],
                    [
                      0.062,
                      0.794,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  109.642,
                  67.99,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.25,
                      -0.161,
                    ],
                    [
                      2.239,
                      -1.444,
                    ],
                    [
                      -0.037,
                      -0.097,
                    ],
                    [
                      -0.956,
                      -2.509,
                    ],
                    [
                      0.105,
                      0.277,
                    ],
                    [
                      0.83,
                      2.179,
                    ],
                    [
                      0.183,
                      0.178,
                    ],
                    [
                      -0.269,
                      0.019,
                    ],
                    [
                      -0.097,
                      0.063,
                    ],
                    [
                      -1.141,
                      0.736,
                    ],
                    [
                      -0.917,
                      0.591,
                    ],
                  ],
                  o: [
                    [
                      -2.239,
                      1.445,
                    ],
                    [
                      -0.079,
                      0.051,
                    ],
                    [
                      0.956,
                      2.509,
                    ],
                    [
                      0.104,
                      0.274,
                    ],
                    [
                      -0.83,
                      -2.179,
                    ],
                    [
                      -0.089,
                      -0.233,
                    ],
                    [
                      0.135,
                      0.13,
                    ],
                    [
                      0.115,
                      -0.008,
                    ],
                    [
                      1.142,
                      -0.736,
                    ],
                    [
                      0.917,
                      -0.592,
                    ],
                    [
                      0.247,
                      -0.16,
                    ],
                  ],
                  v: [
                    [
                      3.191,
                      -6.117,
                    ],
                    [
                      -3.527,
                      -1.783,
                    ],
                    [
                      -3.633,
                      -1.523,
                    ],
                    [
                      -0.765,
                      6.003,
                    ],
                    [
                      -0.322,
                      5.882,
                    ],
                    [
                      -2.813,
                      -0.656,
                    ],
                    [
                      -3.178,
                      -1.613,
                    ],
                    [
                      -3.185,
                      -1.457,
                    ],
                    [
                      -2.754,
                      -1.736,
                    ],
                    [
                      0.671,
                      -3.945,
                    ],
                    [
                      3.423,
                      -5.72,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  64.817,
                  43.17,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.131,
                      0.215,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.216,
                      0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.131,
                      -0.215,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.216,
                      -0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.13,
                      -0.216,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.216,
                      -0.131,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.131,
                      0.215,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.215,
                      0.131,
                    ],
                  ],
                  v: [
                    [
                      -2.908,
                      1.832,
                    ],
                    [
                      -2.967,
                      1.736,
                    ],
                    [
                      -2.812,
                      1.108,
                    ],
                    [
                      2.28,
                      -1.985,
                    ],
                    [
                      2.908,
                      -1.832,
                    ],
                    [
                      2.965,
                      -1.736,
                    ],
                    [
                      2.812,
                      -1.108,
                    ],
                    [
                      -2.281,
                      1.985,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.552999997606,
                  0.552999997606,
                  0.552999997606,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  71.166,
                  20.062,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.724,
                      0,
                    ],
                    [
                      0.423,
                      0.144,
                    ],
                    [
                      0.434,
                      1.108,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.548,
                      0.933,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.126,
                      -0.382,
                    ],
                    [
                      -0.433,
                      -1.108,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.075,
                      0.366,
                    ],
                    [
                      0.973,
                      -0.586,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.904,
                      -2.673,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.075,
                      -0.365,
                    ],
                    [
                      -0.972,
                      0.586,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      1.151,
                    ],
                    [
                      -2.854,
                      0,
                    ],
                    [
                      -0.843,
                      -1.838,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.685,
                      1.748,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.685,
                      -1.016,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.99,
                      0,
                    ],
                    [
                      0,
                      -2.753,
                    ],
                    [
                      -0.715,
                      -0.893,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -0.437,
                      0,
                    ],
                    [
                      -1.126,
                      -0.383,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.938,
                      -2.772,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.019,
                      -0.615,
                    ],
                    [
                      1.126,
                      0.383,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.415,
                      -1.058,
                    ],
                    [
                      -1.074,
                      -0.365,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.497,
                      0.903,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.413,
                      1.058,
                    ],
                    [
                      1.074,
                      0.366,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.698,
                      -0.91,
                    ],
                    [
                      0,
                      -2.855,
                    ],
                    [
                      2.028,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.608,
                      -0.969,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.717,
                      1.832,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.793,
                      -1.827,
                    ],
                    [
                      -2.753,
                      0,
                    ],
                    [
                      0,
                      1.144,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.636,
                      0.384,
                    ],
                  ],
                  v: [
                    [
                      -1.739,
                      53.201,
                    ],
                    [
                      -3.037,
                      52.986,
                    ],
                    [
                      -5.491,
                      50.641,
                    ],
                    [
                      -35.496,
                      -26.385,
                    ],
                    [
                      -33.033,
                      -32.76,
                    ],
                    [
                      -0.461,
                      -52.454,
                    ],
                    [
                      2.914,
                      -52.818,
                    ],
                    [
                      5.368,
                      -50.473,
                    ],
                    [
                      27.616,
                      6.637,
                    ],
                    [
                      27.446,
                      6.704,
                    ],
                    [
                      5.198,
                      -50.406,
                    ],
                    [
                      2.855,
                      -52.645,
                    ],
                    [
                      -0.366,
                      -52.297,
                    ],
                    [
                      -32.938,
                      -32.604,
                    ],
                    [
                      -35.323,
                      -26.448,
                    ],
                    [
                      -5.319,
                      50.574,
                    ],
                    [
                      -2.977,
                      52.811,
                    ],
                    [
                      0.243,
                      52.464,
                    ],
                    [
                      11.925,
                      45.436,
                    ],
                    [
                      10.859,
                      42.289,
                    ],
                    [
                      16.035,
                      37.111,
                    ],
                    [
                      20.742,
                      40.133,
                    ],
                    [
                      33.951,
                      32.186,
                    ],
                    [
                      35.545,
                      27.495,
                    ],
                    [
                      32.014,
                      18.43,
                    ],
                    [
                      32.185,
                      18.363,
                    ],
                    [
                      35.717,
                      27.428,
                    ],
                    [
                      34.046,
                      32.344,
                    ],
                    [
                      20.658,
                      40.396,
                    ],
                    [
                      20.616,
                      40.301,
                    ],
                    [
                      16.035,
                      37.296,
                    ],
                    [
                      11.042,
                      42.289,
                    ],
                    [
                      12.134,
                      45.404,
                    ],
                    [
                      12.199,
                      45.485,
                    ],
                    [
                      12.11,
                      45.54,
                    ],
                    [
                      0.338,
                      52.621,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.552999997606,
                  0.552999997606,
                  0.552999997606,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.119,
                  59.197,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      2.088,
                      -1.259,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.876,
                      -2.59,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.088,
                      1.258,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      1.2,
                    ],
                    [
                      -2.809,
                      0,
                    ],
                    [
                      -0.783,
                      -1.801,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.698,
                      1.785,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.889,
                      -2.271,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.641,
                      0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.889,
                      2.272,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.695,
                      -0.87,
                    ],
                    [
                      0,
                      -2.809,
                    ],
                    [
                      2.089,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.641,
                      -0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      27.51,
                      6.587,
                    ],
                    [
                      5.261,
                      -50.523,
                    ],
                    [
                      -0.434,
                      -52.459,
                    ],
                    [
                      -33.008,
                      -32.766,
                    ],
                    [
                      -35.432,
                      -26.502,
                    ],
                    [
                      -5.427,
                      50.523,
                    ],
                    [
                      0.269,
                      52.46,
                    ],
                    [
                      12.04,
                      45.378,
                    ],
                    [
                      10.929,
                      42.206,
                    ],
                    [
                      16.014,
                      37.121,
                    ],
                    [
                      20.68,
                      40.18,
                    ],
                    [
                      33.977,
                      32.181,
                    ],
                    [
                      35.61,
                      27.378,
                    ],
                    [
                      32.078,
                      18.313,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.14,
                  59.281,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 15',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.108,
                      0,
                    ],
                    [
                      0,
                      -2.108,
                    ],
                    [
                      -2.108,
                      0,
                    ],
                    [
                      0,
                      2.109,
                    ],
                  ],
                  o: [
                    [
                      -2.108,
                      0,
                    ],
                    [
                      0,
                      2.109,
                    ],
                    [
                      2.108,
                      0,
                    ],
                    [
                      0,
                      -2.108,
                    ],
                  ],
                  v: [
                    [
                      -0.001,
                      -3.824,
                    ],
                    [
                      -3.824,
                      -0.001,
                    ],
                    [
                      -0.001,
                      3.824,
                    ],
                    [
                      3.824,
                      -0.001,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.21,
                      0,
                    ],
                    [
                      0,
                      2.21,
                    ],
                    [
                      -2.209,
                      0,
                    ],
                    [
                      0,
                      -2.21,
                    ],
                  ],
                  o: [
                    [
                      -2.209,
                      0,
                    ],
                    [
                      0,
                      -2.21,
                    ],
                    [
                      2.21,
                      0,
                    ],
                    [
                      0,
                      2.21,
                    ],
                  ],
                  v: [
                    [
                      -0.001,
                      4.008,
                    ],
                    [
                      -4.008,
                      -0.001,
                    ],
                    [
                      -0.001,
                      -4.008,
                    ],
                    [
                      4.008,
                      -0.001,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Combinar trazados 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.552999997606,
                  0.552999997606,
                  0.552999997606,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  103.155,
                  101.487,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 16',
          np: 6,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.201,
                      -0.639,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      -0.314,
                      0.166,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.196,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.195,
                    ],
                    [
                      -1.941,
                      0.72,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.722000002394,
                  0.325,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  48.398,
                  37.252,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 17',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 17,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.167,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.201,
                      -0.638,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.638,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      -0.314,
                      0.166,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.195,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.196,
                    ],
                    [
                      -1.941,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.722000002394,
                  0.325,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  47.821,
                  35.833,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 18',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 18,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      1.201,
                      -0.637,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      -0.314,
                      0.167,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.196,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.196,
                    ],
                    [
                      -1.942,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.722000002394,
                  0.325,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.671,
                  114.683,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 19',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 19,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.167,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      1.201,
                      -0.638,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.638,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      -0.314,
                      0.166,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.195,
                    ],
                    [
                      1.941,
                      -0.72,
                    ],
                    [
                      1.663,
                      -1.196,
                    ],
                    [
                      -1.942,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.722000002394,
                  0.325,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.094,
                  113.264,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 20',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 20,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.201,
                      0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.202,
                      -0.637,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      -0.313,
                      0.167,
                    ],
                  ],
                  v: [
                    [
                      -1.664,
                      1.196,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.195,
                    ],
                    [
                      -1.942,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.722000002394,
                  0.325,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  75.801,
                  107.558,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 21',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 21,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.201,
                      -0.637,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.313,
                      -0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      -0.314,
                      0.167,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.196,
                    ],
                    [
                      1.942,
                      -0.719,
                    ],
                    [
                      1.664,
                      -1.195,
                    ],
                    [
                      -1.941,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.722000002394,
                  0.325,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  74.845,
                  105.047,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 22',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 22,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.641,
                      -0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.889,
                      2.271,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.642,
                      0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.888,
                      -2.271,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.698,
                      1.785,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.088,
                      1.259,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.876,
                      -2.59,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      2.089,
                      -1.259,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      34.056,
                      16.546,
                    ],
                    [
                      39.506,
                      30.467,
                    ],
                    [
                      37.874,
                      35.27,
                    ],
                    [
                      -0.13,
                      57.977,
                    ],
                    [
                      -5.826,
                      56.042,
                    ],
                    [
                      -39.327,
                      -29.59,
                    ],
                    [
                      -36.902,
                      -35.854,
                    ],
                    [
                      -0.036,
                      -57.977,
                    ],
                    [
                      5.661,
                      -56.041,
                    ],
                    [
                      29.503,
                      4.898,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.136999990426,
                  0.136999990426,
                  0.136999990426,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.411,
                  60.672,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 23',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 23,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.209,
                      0,
                    ],
                    [
                      0.691,
                      0.236,
                    ],
                    [
                      0.702,
                      1.795,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.778,
                      1.675,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.116,
                      -2.854,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.712,
                      -0.582,
                    ],
                    [
                      -1.614,
                      0.974,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -0.717,
                      0,
                    ],
                    [
                      -1.815,
                      -0.617,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.182,
                      -3.02,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.624,
                      1.582,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.663,
                      1.695,
                    ],
                    [
                      1.756,
                      0.596,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.072,
                      0.647,
                    ],
                  ],
                  v: [
                    [
                      6.273,
                      55.553,
                    ],
                    [
                      4.147,
                      55.202,
                    ],
                    [
                      0.185,
                      51.406,
                    ],
                    [
                      -31.797,
                      -30.341,
                    ],
                    [
                      -29.043,
                      -38.445,
                    ],
                    [
                      -0.545,
                      -55.553,
                    ],
                    [
                      -0.356,
                      -55.238,
                    ],
                    [
                      -28.853,
                      -38.13,
                    ],
                    [
                      -31.455,
                      -30.475,
                    ],
                    [
                      0.527,
                      51.271,
                    ],
                    [
                      4.265,
                      54.855,
                    ],
                    [
                      9.57,
                      54.262,
                    ],
                    [
                      32.791,
                      40.398,
                    ],
                    [
                      32.979,
                      40.712,
                    ],
                    [
                      9.759,
                      54.576,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.925,
                  0.458999992819,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.65,
                  64.797,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 24',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 24,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.457,
                      3.726,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.693,
                      1.623,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -3.425,
                      2.066,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.146,
                      -2.928,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      32.829,
                      40.011,
                    ],
                    [
                      9.607,
                      53.874,
                    ],
                    [
                      0.299,
                      50.793,
                    ],
                    [
                      -31.683,
                      -30.952,
                    ],
                    [
                      -29.005,
                      -38.831,
                    ],
                    [
                      -0.508,
                      -55.94,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.925,
                  0.458999992819,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.707,
                  65.342,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 25',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 25,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -5.159,
                      -1.717,
                    ],
                    [
                      -2.346,
                      1.028,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -6.68,
                      14.168,
                    ],
                    [
                      1.469,
                      0.796,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.081,
                      0.584,
                    ],
                    [
                      -0.007,
                      0.043,
                    ],
                    [
                      2.478,
                      5.167,
                    ],
                    [
                      2.628,
                      2.2,
                    ],
                    [
                      1.834,
                      0.197,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.29,
                      0.852,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.122,
                      -1.072,
                    ],
                    [
                      0.498,
                      -0.31,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      6.237,
                      2.077,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.47,
                      -0.795,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.005,
                      -0.04,
                    ],
                    [
                      0.17,
                      -1.069,
                    ],
                    [
                      -0.853,
                      -1.777,
                    ],
                    [
                      -2.627,
                      -2.2,
                    ],
                    [
                      -0.431,
                      -0.046,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.364,
                      -0.901,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.08,
                      0.71,
                    ],
                    [
                      -0.496,
                      0.311,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -29.209,
                      16.982,
                    ],
                    [
                      -18.522,
                      22.508,
                    ],
                    [
                      -3.854,
                      24.399,
                    ],
                    [
                      9.829,
                      32.574,
                    ],
                    [
                      29.21,
                      16.025,
                    ],
                    [
                      17.477,
                      7.782,
                    ],
                    [
                      11.982,
                      2.028,
                    ],
                    [
                      12.282,
                      0.548,
                    ],
                    [
                      12.303,
                      0.423,
                    ],
                    [
                      9.63,
                      -9.608,
                    ],
                    [
                      2.487,
                      -21.973,
                    ],
                    [
                      -3.5,
                      -25.715,
                    ],
                    [
                      -6.391,
                      -25.928,
                    ],
                    [
                      -11.097,
                      -28.865,
                    ],
                    [
                      -15.981,
                      -32.574,
                    ],
                    [
                      -4.138,
                      -2.245,
                    ],
                    [
                      -3.992,
                      -0.627,
                    ],
                    [
                      -5.204,
                      1.723,
                    ],
                    [
                      -6.107,
                      2.377,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  128.449,
                  89.023,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 26',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 26,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.631,
                      -3.944,
                    ],
                    [
                      -3.658,
                      0.618,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.631,
                      3.942,
                    ],
                    [
                      3.657,
                      -0.618,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      8.654,
                      -4.688,
                    ],
                    [
                      -2.96,
                      -3.858,
                    ],
                    [
                      -8.956,
                      0.538,
                    ],
                    [
                      0.359,
                      4.07,
                    ],
                    [
                      9.587,
                      3.876,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  60.786,
                  57.576,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 27',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 27,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.16,
                      -4.239,
                    ],
                    [
                      -2.267,
                      0.321,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.161,
                      4.238,
                    ],
                    [
                      2.267,
                      -0.321,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      7.161,
                      -4.53,
                    ],
                    [
                      -3.586,
                      -4.061,
                    ],
                    [
                      -9.525,
                      0.131,
                    ],
                    [
                      -1.116,
                      4.209,
                    ],
                    [
                      9.686,
                      3.566,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  64.799,
                  70.817,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 28',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 28,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.363,
                      -3.152,
                    ],
                    [
                      -3.893,
                      -0.276,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.364,
                      3.151,
                    ],
                    [
                      3.894,
                      0.277,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      7.956,
                      -3.076,
                    ],
                    [
                      -3.462,
                      -3.076,
                    ],
                    [
                      -9.587,
                      -0.623,
                    ],
                    [
                      -2.072,
                      3.498,
                    ],
                    [
                      9.951,
                      3.498,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  71.67,
                  86.238,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 29',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 29,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 5,
      ty: 4,
      nm: 'Capa 4 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 0,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 14,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 100,
              s: [
                100,
              ],
            },
            {
              t: 115,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 0,
              s: [
                93,
                103.5,
                9,
              ],
              to: [
                0,
                -4.833,
                -1.5,
              ],
              ti: [
                0,
                4.833,
                1.5,
              ],
            },
            {
              t: 14,
              s: [
                93,
                74.5,
                0,
              ],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.603,
                      0,
                    ],
                    [
                      0.44,
                      0.248,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.707,
                      -0.263,
                    ],
                    [
                      0.785,
                      0.09,
                    ],
                    [
                      -0.785,
                      0.015,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  7.993,
                  120.65,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.196,
                      0.111,
                    ],
                    [
                      0.444,
                      0.323,
                    ],
                    [
                      -0.866,
                      0.043,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.719,
                      -0.194,
                    ],
                    [
                      -0.719,
                      -0.13,
                    ],
                    [
                      0.343,
                      0.135,
                    ],
                    [
                      0.353,
                      -0.038,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  37.563,
                  126.793,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.017,
                      1.207,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.837,
                      -0.11,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.883,
                      -0.533,
                    ],
                    [
                      -0.665,
                      -0.674,
                    ],
                    [
                      0.883,
                      0.518,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  33.125,
                  130.027,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.162,
                      0.226,
                    ],
                    [
                      1.231,
                      0.264,
                    ],
                    [
                      -0.798,
                      0.25,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.931,
                      -0.442,
                    ],
                    [
                      -0.931,
                      0.129,
                    ],
                    [
                      0.53,
                      0.193,
                    ],
                    [
                      0.535,
                      0.027,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  35.842,
                  130.704,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      8.403,
                      3.931,
                    ],
                    [
                      -1.936,
                      -8.237,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -5.197,
                      -5.604,
                    ],
                    [
                      5.197,
                      5.604,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  23.119,
                  135.94,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.794,
                      1.827,
                    ],
                    [
                      -2.7,
                      0.103,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -2.227,
                      -0.913,
                    ],
                    [
                      2.228,
                      -0.102,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  25.089,
                  154.805,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.385,
                      2.165,
                    ],
                    [
                      -0.652,
                      -1.601,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.479,
                      -2.169,
                    ],
                    [
                      0.173,
                      2.169,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.675,
                  0.616000007181,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.389,
                  156.82,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.18,
                      -0.333,
                    ],
                    [
                      1.487,
                      -1.512,
                    ],
                    [
                      -0.846,
                      -2.897,
                    ],
                    [
                      0.154,
                      -2.795,
                    ],
                    [
                      2.641,
                      -2.256,
                    ],
                    [
                      -0.539,
                      -3.538,
                    ],
                    [
                      8.665,
                      5.45,
                    ],
                    [
                      -0.136,
                      0,
                    ],
                    [
                      3.077,
                      8,
                    ],
                    [
                      -0.417,
                      3.032,
                    ],
                    [
                      -0.194,
                      1.939,
                    ],
                    [
                      -1.44,
                      1.897,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.846,
                      -1.606,
                    ],
                    [
                      4.988,
                      -9.33,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.923,
                      -0.398,
                    ],
                    [
                      -2.553,
                      -2.603,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.846,
                      2.899,
                    ],
                    [
                      -0.154,
                      2.795,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.162,
                      -0.101,
                    ],
                    [
                      0.137,
                      0,
                    ],
                    [
                      -3.077,
                      -8,
                    ],
                    [
                      0.396,
                      -2.882,
                    ],
                    [
                      0.167,
                      -1.663,
                    ],
                    [
                      1.836,
                      -2.419,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.742,
                      1.388,
                    ],
                    [
                      0.351,
                      0.424,
                    ],
                    [
                      1.379,
                      0.593,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      16.987,
                      -12.485,
                    ],
                    [
                      15.296,
                      -10.433,
                    ],
                    [
                      13.756,
                      -6.459,
                    ],
                    [
                      14.474,
                      -0.331,
                    ],
                    [
                      16.115,
                      8.773,
                    ],
                    [
                      12.628,
                      15.388,
                    ],
                    [
                      11.064,
                      24.747,
                    ],
                    [
                      -9.254,
                      22.79,
                    ],
                    [
                      -9.254,
                      14.037,
                    ],
                    [
                      -13.596,
                      5.764,
                    ],
                    [
                      -16.57,
                      -7.707,
                    ],
                    [
                      -15.579,
                      -14.51,
                    ],
                    [
                      -13.972,
                      -19.468,
                    ],
                    [
                      -9.493,
                      -25.929,
                    ],
                    [
                      -6.006,
                      -26.204,
                    ],
                    [
                      -6.792,
                      -14.134,
                    ],
                    [
                      -6.674,
                      -7.836,
                    ],
                    [
                      -4.399,
                      -6.715,
                    ],
                    [
                      1.767,
                      -2.587,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.62,
                  137.19,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.641,
                      -0.471,
                    ],
                    [
                      0.827,
                      -1.713,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.641,
                      0.469,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.813,
                      -1.924,
                    ],
                    [
                      -0.097,
                      -2.53,
                    ],
                    [
                      0.986,
                      1.581,
                    ],
                    [
                      0.049,
                      3.001,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  43.656,
                  114.808,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.361,
                      -1.4,
                    ],
                    [
                      0.848,
                      -0.295,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.361,
                      1.4,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -2.111,
                      -1.935,
                    ],
                    [
                      0.749,
                      -1.479,
                    ],
                    [
                      -0.118,
                      2.879,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  40.969,
                  106.899,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.103,
                      -2.772,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.698,
                      1.754,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.96,
                      -1.801,
                    ],
                    [
                      1.262,
                      -0.283,
                    ],
                    [
                      -0.139,
                      3.055,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  38.258,
                  99.908,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.879,
                      1.791,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.309,
                      -2.666,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.099,
                      3.072,
                    ],
                    [
                      1.126,
                      -0.406,
                    ],
                    [
                      -2.005,
                      -2.008,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  35.418,
                  92.661,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 6,
      ty: 3,
      nm: 'Capa 4',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 0,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 14,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 100,
              s: [
                100,
              ],
            },
            {
              t: 115,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 0,
              s: [
                93,
                103.5,
                9,
              ],
              to: [
                0,
                -4.833,
                -1.5,
              ],
              ti: [
                0,
                4.833,
                1.5,
              ],
            },
            {
              t: 14,
              s: [
                93,
                74.5,
                0,
              ],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 7,
      ty: 4,
      nm: 'Capa 5 contornos',
      parent: 6,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 0,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 14,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 100,
              s: [
                100,
              ],
            },
            {
              t: 115,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.815,
                      6.983,
                    ],
                    [
                      -3.001,
                      -6.919,
                    ],
                    [
                      -2.815,
                      -6.984,
                    ],
                    [
                      3.002,
                      6.92,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  27.619,
                  113.815,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.654,
                      6.6,
                    ],
                    [
                      -2.841,
                      -6.536,
                    ],
                    [
                      -2.655,
                      -6.6,
                    ],
                    [
                      2.84,
                      6.536,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  31.452,
                  110.865,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.965,
                      7.342,
                    ],
                    [
                      -3.151,
                      -7.277,
                    ],
                    [
                      -2.965,
                      -7.342,
                    ],
                    [
                      3.151,
                      7.278,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  29.924,
                  112.818,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.473,
                      6.675,
                    ],
                    [
                      -3.032,
                      -6.483,
                    ],
                    [
                      -2.473,
                      -6.676,
                    ],
                    [
                      3.032,
                      6.483,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  34.007,
                  108.788,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.007,
                      0.02,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.018,
                      0.008,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.007,
                      -0.019,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.02,
                      -0.007,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.007,
                      -0.018,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.019,
                      -0.006,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.007,
                      0.018,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.019,
                      0.007,
                    ],
                  ],
                  v: [
                    [
                      5.191,
                      21.999,
                    ],
                    [
                      -10.234,
                      -18.755,
                    ],
                    [
                      -10.214,
                      -18.802,
                    ],
                    [
                      -5.238,
                      -22.021,
                    ],
                    [
                      -5.191,
                      -21.999,
                    ],
                    [
                      10.234,
                      18.755,
                    ],
                    [
                      10.212,
                      18.802,
                    ],
                    [
                      5.238,
                      22.02,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  17.445,
                  110.336,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.27,
                      0.542,
                    ],
                    [
                      0.151,
                      0.131,
                    ],
                    [
                      0.59,
                      -0.585,
                    ],
                    [
                      1.999,
                      -0.998,
                    ],
                    [
                      -0.047,
                      -0.093,
                    ],
                    [
                      -0.093,
                      0.046,
                    ],
                    [
                      -0.393,
                      0.39,
                    ],
                    [
                      -0.449,
                      -0.387,
                    ],
                    [
                      -0.067,
                      -0.134,
                    ],
                    [
                      0.296,
                      -0.345,
                    ],
                    [
                      0.986,
                      -0.52,
                    ],
                    [
                      -0.046,
                      -0.092,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.091,
                      0.048,
                    ],
                    [
                      -0.626,
                      0.731,
                    ],
                  ],
                  o: [
                    [
                      -0.089,
                      -0.178,
                    ],
                    [
                      -0.599,
                      -0.517,
                    ],
                    [
                      -0.322,
                      0.319,
                    ],
                    [
                      -0.093,
                      0.046,
                    ],
                    [
                      0.046,
                      0.094,
                    ],
                    [
                      1.8,
                      -0.897,
                    ],
                    [
                      0.449,
                      -0.445,
                    ],
                    [
                      0.114,
                      0.099,
                    ],
                    [
                      0.202,
                      0.406,
                    ],
                    [
                      -0.587,
                      0.685,
                    ],
                    [
                      -0.09,
                      0.048,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.048,
                      0.091,
                    ],
                    [
                      1.015,
                      -0.536,
                    ],
                    [
                      0.393,
                      -0.46,
                    ],
                  ],
                  v: [
                    [
                      3.295,
                      -1.386,
                    ],
                    [
                      2.933,
                      -1.852,
                    ],
                    [
                      0.847,
                      -1.735,
                    ],
                    [
                      -3.434,
                      0.693,
                    ],
                    [
                      -3.518,
                      0.945,
                    ],
                    [
                      -3.267,
                      1.029,
                    ],
                    [
                      1.112,
                      -1.467,
                    ],
                    [
                      2.687,
                      -1.568,
                    ],
                    [
                      2.959,
                      -1.217,
                    ],
                    [
                      2.806,
                      0.02,
                    ],
                    [
                      -0.065,
                      1.988,
                    ],
                    [
                      -0.145,
                      2.238,
                    ],
                    [
                      -0.143,
                      2.243,
                    ],
                    [
                      0.11,
                      2.32,
                    ],
                    [
                      3.092,
                      0.262,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  21.417,
                  92.316,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.125,
                      0.062,
                    ],
                    [
                      0.046,
                      0.093,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.093,
                      -0.046,
                    ],
                    [
                      0.197,
                      -0.104,
                    ],
                    [
                      0.215,
                      -0.098,
                    ],
                    [
                      -0.043,
                      -0.095,
                    ],
                    [
                      -0.001,
                      -0.002,
                    ],
                    [
                      -0.093,
                      0.042,
                    ],
                    [
                      -0.291,
                      0.153,
                    ],
                  ],
                  o: [
                    [
                      0.093,
                      -0.046,
                    ],
                    [
                      0,
                      -0.001,
                    ],
                    [
                      -0.045,
                      -0.093,
                    ],
                    [
                      -0.126,
                      0.062,
                    ],
                    [
                      -0.286,
                      0.151,
                    ],
                    [
                      -0.095,
                      0.043,
                    ],
                    [
                      0.001,
                      0.002,
                    ],
                    [
                      0.045,
                      0.089,
                    ],
                    [
                      0.224,
                      -0.102,
                    ],
                    [
                      0.194,
                      -0.103,
                    ],
                  ],
                  v: [
                    [
                      0.751,
                      -0.173,
                    ],
                    [
                      0.837,
                      -0.424,
                    ],
                    [
                      0.836,
                      -0.425,
                    ],
                    [
                      0.585,
                      -0.51,
                    ],
                    [
                      0.079,
                      -0.248,
                    ],
                    [
                      -0.747,
                      0.173,
                    ],
                    [
                      -0.84,
                      0.422,
                    ],
                    [
                      -0.837,
                      0.428,
                    ],
                    [
                      -0.591,
                      0.514,
                    ],
                    [
                      0.254,
                      0.085,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  19.917,
                  95.201,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.901,
                      -0.487,
                    ],
                    [
                      -0.049,
                      0.091,
                    ],
                    [
                      0.091,
                      0.05,
                    ],
                    [
                      0.979,
                      -0.872,
                    ],
                    [
                      1.94,
                      -0.968,
                    ],
                    [
                      -0.047,
                      -0.094,
                    ],
                    [
                      -0.094,
                      0.046,
                    ],
                    [
                      -0.044,
                      0.04,
                    ],
                  ],
                  o: [
                    [
                      0.091,
                      0.05,
                    ],
                    [
                      0.05,
                      -0.091,
                    ],
                    [
                      -1.04,
                      -0.563,
                    ],
                    [
                      -0.011,
                      0.009,
                    ],
                    [
                      -0.093,
                      0.046,
                    ],
                    [
                      0.046,
                      0.093,
                    ],
                    [
                      1.985,
                      -0.99,
                    ],
                    [
                      0.86,
                      -0.765,
                    ],
                  ],
                  v: [
                    [
                      3.022,
                      -0.806,
                    ],
                    [
                      3.276,
                      -0.881,
                    ],
                    [
                      3.201,
                      -1.136,
                    ],
                    [
                      -0.173,
                      -0.621,
                    ],
                    [
                      -3.195,
                      1.317,
                    ],
                    [
                      -3.279,
                      1.569,
                    ],
                    [
                      -3.027,
                      1.653,
                    ],
                    [
                      0.078,
                      -0.342,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  21.515,
                  90.265,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.506,
                      1.016,
                    ],
                    [
                      0.127,
                      0.157,
                    ],
                    [
                      0.081,
                      -0.065,
                    ],
                    [
                      -0.064,
                      -0.082,
                    ],
                    [
                      -0.079,
                      -0.158,
                    ],
                    [
                      0.64,
                      -0.747,
                    ],
                    [
                      2.749,
                      -1.254,
                    ],
                    [
                      -0.043,
                      -0.094,
                    ],
                    [
                      -0.001,
                      -0.002,
                    ],
                    [
                      -0.092,
                      0.042,
                    ],
                    [
                      -0.811,
                      0.948,
                    ],
                  ],
                  o: [
                    [
                      -0.091,
                      -0.183,
                    ],
                    [
                      -0.065,
                      -0.081,
                    ],
                    [
                      -0.08,
                      0.065,
                    ],
                    [
                      0.11,
                      0.135,
                    ],
                    [
                      0.439,
                      0.88,
                    ],
                    [
                      -0.76,
                      0.889,
                    ],
                    [
                      -0.094,
                      0.043,
                    ],
                    [
                      0.001,
                      0.002,
                    ],
                    [
                      0.045,
                      0.09,
                    ],
                    [
                      2.86,
                      -1.305,
                    ],
                    [
                      0.737,
                      -0.861,
                    ],
                  ],
                  v: [
                    [
                      2.671,
                      -2.784,
                    ],
                    [
                      2.342,
                      -3.295,
                    ],
                    [
                      2.078,
                      -3.323,
                    ],
                    [
                      2.05,
                      -3.059,
                    ],
                    [
                      2.335,
                      -2.616,
                    ],
                    [
                      2.004,
                      0.062,
                    ],
                    [
                      -3.041,
                      3.004,
                    ],
                    [
                      -3.134,
                      3.252,
                    ],
                    [
                      -3.131,
                      3.259,
                    ],
                    [
                      -2.885,
                      3.346,
                    ],
                    [
                      2.29,
                      0.306,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  23.218,
                  93.128,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.622,
                      1.367,
                    ],
                    [
                      0.433,
                      0.375,
                    ],
                    [
                      1.474,
                      -1.342,
                    ],
                    [
                      0.169,
                      -0.118,
                    ],
                    [
                      1.202,
                      -0.6,
                    ],
                    [
                      -0.046,
                      -0.094,
                    ],
                    [
                      -0.093,
                      0.045,
                    ],
                    [
                      -0.404,
                      0.28,
                    ],
                    [
                      -0.156,
                      0.143,
                    ],
                    [
                      -1.367,
                      -1.182,
                    ],
                    [
                      -0.216,
                      -0.47,
                    ],
                    [
                      1.001,
                      -1.01,
                    ],
                    [
                      1.62,
                      -0.753,
                    ],
                    [
                      -0.043,
                      -0.093,
                    ],
                    [
                      -0.094,
                      0.044,
                    ],
                    [
                      -0.908,
                      0.916,
                    ],
                  ],
                  o: [
                    [
                      -0.236,
                      -0.524,
                    ],
                    [
                      -1.51,
                      -1.305,
                    ],
                    [
                      -0.147,
                      0.134,
                    ],
                    [
                      -0.381,
                      0.265,
                    ],
                    [
                      -0.093,
                      0.046,
                    ],
                    [
                      0.046,
                      0.092,
                    ],
                    [
                      1.253,
                      -0.625,
                    ],
                    [
                      0.188,
                      -0.131,
                    ],
                    [
                      1.333,
                      -1.214,
                    ],
                    [
                      0.392,
                      0.339,
                    ],
                    [
                      0.552,
                      1.217,
                    ],
                    [
                      -0.865,
                      0.873,
                    ],
                    [
                      -0.095,
                      0.044,
                    ],
                    [
                      0.048,
                      0.09,
                    ],
                    [
                      1.651,
                      -0.767,
                    ],
                    [
                      1.117,
                      -1.128,
                    ],
                  ],
                  v: [
                    [
                      4.283,
                      -2.251,
                    ],
                    [
                      3.271,
                      -3.605,
                    ],
                    [
                      -1.962,
                      -3.54,
                    ],
                    [
                      -2.436,
                      -3.147,
                    ],
                    [
                      -4.775,
                      -1.901,
                    ],
                    [
                      -4.859,
                      -1.649,
                    ],
                    [
                      -4.607,
                      -1.565,
                    ],
                    [
                      -2.221,
                      -2.839,
                    ],
                    [
                      -1.709,
                      -3.263,
                    ],
                    [
                      3.026,
                      -3.32,
                    ],
                    [
                      3.942,
                      -2.096,
                    ],
                    [
                      3.116,
                      2.011,
                    ],
                    [
                      -1.143,
                      4.525,
                    ],
                    [
                      -1.235,
                      4.775,
                    ],
                    [
                      -0.985,
                      4.866,
                    ],
                    [
                      3.384,
                      2.274,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.676,
                  92.223,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -1.784,
                      -0.611,
                    ],
                    [
                      -0.033,
                      0.098,
                    ],
                    [
                      0.098,
                      0.034,
                    ],
                    [
                      2.411,
                      -2.256,
                    ],
                    [
                      -0.036,
                      -0.072,
                    ],
                    [
                      -0.013,
                      -0.014,
                    ],
                    [
                      -0.076,
                      0.07,
                    ],
                  ],
                  o: [
                    [
                      0.098,
                      0.033,
                    ],
                    [
                      0.034,
                      -0.098,
                    ],
                    [
                      -1.342,
                      -0.46,
                    ],
                    [
                      -0.062,
                      0.058,
                    ],
                    [
                      0.008,
                      0.016,
                    ],
                    [
                      0.071,
                      0.075,
                    ],
                    [
                      1.8,
                      -1.685,
                    ],
                  ],
                  v: [
                    [
                      2.77,
                      -0.411,
                    ],
                    [
                      3.008,
                      -0.528,
                    ],
                    [
                      2.892,
                      -0.766,
                    ],
                    [
                      -2.966,
                      0.956,
                    ],
                    [
                      -3.006,
                      1.176,
                    ],
                    [
                      -2.975,
                      1.221,
                    ],
                    [
                      -2.709,
                      1.23,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  21.952,
                  87.452,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.516,
                      0.604,
                    ],
                    [
                      0.911,
                      1.828,
                    ],
                    [
                      0.51,
                      0.441,
                    ],
                    [
                      0.306,
                      0.18,
                    ],
                    [
                      0.053,
                      -0.09,
                    ],
                    [
                      -0.09,
                      -0.053,
                    ],
                    [
                      -0.265,
                      -0.229,
                    ],
                    [
                      -0.278,
                      -0.558,
                    ],
                    [
                      1.23,
                      -1.437,
                    ],
                    [
                      0.621,
                      -0.389,
                    ],
                    [
                      -0.043,
                      -0.086,
                    ],
                    [
                      -0.004,
                      -0.005,
                    ],
                    [
                      -0.088,
                      0.054,
                    ],
                  ],
                  o: [
                    [
                      1.328,
                      -1.552,
                    ],
                    [
                      -0.301,
                      -0.602,
                    ],
                    [
                      -0.283,
                      -0.244,
                    ],
                    [
                      -0.089,
                      -0.052,
                    ],
                    [
                      -0.052,
                      0.089,
                    ],
                    [
                      0.286,
                      0.168,
                    ],
                    [
                      0.472,
                      0.409,
                    ],
                    [
                      0.844,
                      1.692,
                    ],
                    [
                      -0.51,
                      0.597,
                    ],
                    [
                      -0.083,
                      0.052,
                    ],
                    [
                      0.002,
                      0.004,
                    ],
                    [
                      0.055,
                      0.088,
                    ],
                    [
                      0.781,
                      -0.491,
                    ],
                  ],
                  v: [
                    [
                      0.525,
                      2.984,
                    ],
                    [
                      1.212,
                      -2.579,
                    ],
                    [
                      -0.01,
                      -4.15,
                    ],
                    [
                      -0.898,
                      -4.79,
                    ],
                    [
                      -1.154,
                      -4.723,
                    ],
                    [
                      -1.087,
                      -4.465,
                    ],
                    [
                      -0.257,
                      -3.867,
                    ],
                    [
                      0.874,
                      -2.41,
                    ],
                    [
                      0.24,
                      2.74,
                    ],
                    [
                      -2.012,
                      4.469,
                    ],
                    [
                      -2.079,
                      4.713,
                    ],
                    [
                      -2.07,
                      4.728,
                    ],
                    [
                      -1.811,
                      4.788,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  26.695,
                  91.916,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.07,
                      0.076,
                    ],
                    [
                      0.077,
                      -0.07,
                    ],
                    [
                      3.607,
                      -1.646,
                    ],
                    [
                      -0.044,
                      -0.094,
                    ],
                    [
                      -0.001,
                      -0.002,
                    ],
                    [
                      -0.092,
                      0.043,
                    ],
                    [
                      -0.057,
                      0.052,
                    ],
                  ],
                  o: [
                    [
                      -0.07,
                      -0.076,
                    ],
                    [
                      -0.013,
                      0.013,
                    ],
                    [
                      -0.095,
                      0.043,
                    ],
                    [
                      0,
                      0.002,
                    ],
                    [
                      0.045,
                      0.09,
                    ],
                    [
                      3.663,
                      -1.669,
                    ],
                    [
                      0.076,
                      -0.07,
                    ],
                  ],
                  v: [
                    [
                      2.663,
                      -1.597,
                    ],
                    [
                      2.397,
                      -1.609,
                    ],
                    [
                      -2.596,
                      1.296,
                    ],
                    [
                      -2.689,
                      1.544,
                    ],
                    [
                      -2.686,
                      1.549,
                    ],
                    [
                      -2.441,
                      1.635,
                    ],
                    [
                      2.652,
                      -1.331,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  20.843,
                  93.071,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.312,
                      0.825,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1,
                      -0.643,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.312,
                      -0.825,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1,
                      0.643,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.42,
                      -1.112,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.742,
                      0.477,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.42,
                      1.112,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.742,
                      -0.477,
                    ],
                  ],
                  v: [
                    [
                      20.715,
                      14.182,
                    ],
                    [
                      5.786,
                      -25.137,
                    ],
                    [
                      4.213,
                      -29.297,
                    ],
                    [
                      1.454,
                      -30.208,
                    ],
                    [
                      -15.533,
                      -19.292,
                    ],
                    [
                      -15.551,
                      -19.26,
                    ],
                    [
                      -19.977,
                      -16.415,
                    ],
                    [
                      -20.714,
                      -14.182,
                    ],
                    [
                      -5.785,
                      25.137,
                    ],
                    [
                      -4.212,
                      29.298,
                    ],
                    [
                      -1.454,
                      30.208,
                    ],
                    [
                      15.533,
                      19.292,
                    ],
                    [
                      15.551,
                      19.26,
                    ],
                    [
                      19.977,
                      16.415,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.987999949736,
                  0.905999995213,
                  0.905999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  23.844,
                  105.561,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 0,
      nm: 'Colores 2',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 100,
              s: [
                100,
              ],
            },
            {
              t: 115,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      w: 160,
      h: 165,
      ip: 51,
      op: 801,
      st: 51,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: 'Capa de formas 1',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            64,
            72.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            55.467,
            58.97,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: {
                a: 0,
                k: [
                  315.379,
                  303.961,
                ],
                ix: 2,
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 4,
              },
              nm: 'Trazado de rectángulo 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  28.689,
                  19.48,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Rectángulo 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
